module.exports = __webpack_public_path__ + "static/assets/ff0df5482586d3a39668fa088681b027.png";